import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Components
import Form, { Group } from "~/common/components/Form";
import Textarea from "~/common/components/textarea";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";

//Assets
import "~/assets/sass/pages/portfolio/portfolioMemo.scss";
import { ClipIcon, RoundMinusIcon, UploadIcon } from "~/assets/svg/InterfaceIcon";

const AddMemo = ({
	portfolioIdx,
	pMemoIdx = 0,
	replyTo,
	isEdit,
	files = [],
	memo,
	onAdd,
	onEdit,
}) => {
	const addMemoRequest = useRequest("post", `vc/portfolio/memo/add`);
	const editMemoRequest = useRequest("patch", `vc/portfolio/memo/edit`);
	const memoForm = useForm({
		defaultValues: {
			files: files,
			deleteFile: [],
			memo,
		},
	});

	const { t } = useTranslation();

	const {
		fields: filesFields,
		append: filesAppend,
		remove: filesRemove,
	} = useFieldArray({
		control: memoForm.control,
		name: "files",
	});

	const submit = (data) => {
		const { memo, files } = data;
		memoForm.setValue("memo", "");

		const formData = new FormData();
		formData.append("portfolioIdx", parseInt(portfolioIdx, 10));
		formData.append("content", memo);
		if (files?.length > 0) {
			files.forEach((d) => {
				formData.append("files", d.file);
			});
		}
		if (isEdit) {
			// 수정시엔 memoIdx로 전송
			formData.append("memoIdx", parseInt(pMemoIdx, 10));
			if (data?.deleteFile?.length > 0) {
				formData.append("deleteFile", data.deleteFile);
			}
			return editMemoRequest.call(formData);
		}

		formData.append("pMemoIdx", parseInt(pMemoIdx, 10));
		addMemoRequest.call(formData);
	};

	const addFile = (file) => {
		filesAppend({
			file,
		});
	};

	const removeFile = (index, idx) => {
		if (filesFields.length <= 0) return;
		filesRemove(index);
		console.log("memoForm", memoForm);
		// debugger;
		if (idx) {
			const deleteFile = [...memoForm.watch().deleteFile];
			deleteFile.push(idx);
			memoForm.setValue("deleteFile", deleteFile);
		}
	};

	useEffect(() => {
		switch (addMemoRequest.state) {
			case API_STATE.done:
				memoForm.reset();
				onAdd && onAdd(t("pages.portfolio.PortfolioMemo.components.AddMemo.complete"));
				break;
			default:
				break;
		}
	}, [addMemoRequest.state, addMemoRequest.response]);

	useEffect(() => {
		switch (editMemoRequest.state) {
			case API_STATE.done:
				memoForm.reset();
				onEdit && onEdit(t("pages.portfolio.PortfolioMemo.components.AddMemo.modComplete"));
				break;
			default:
				break;
		}
	}, [editMemoRequest.state, editMemoRequest.response]);

	return (
		<>
			<div className="memo-box">
				<Form useForm={memoForm}>
					{!isEdit && replyTo ? (
						<Group>
							<span className="name-tag">@{replyTo}</span>
							<Textarea
								name="memo"
								placeholder={t(
									"pages.portfolio.PortfolioMemo.components.AddMemo.placeMemo"
								)}
							/>
						</Group>
					) : (
						<Textarea
							name="memo"
							placeholder={t(
								"pages.portfolio.PortfolioMemo.components.AddMemo.placeMemo"
							)}
						/>
					)}

					<div className="c__fileUploader">
						<label className="file-upload" htmlFor={"file-input"}>
							<input
								type="file"
								name="file-input"
								className="file-input"
								{...memoForm.register("file", {
									onChange: (e) => {
										addFile(e.target.files[0]);
									},
								})}
							/>
							<UploadIcon />
						</label>
						<button
							className="btn__solid"
							color="primary"
							onClick={memoForm.handleSubmit(submit)}
						>
							{isEdit
								? t("pages.portfolio.PortfolioMemo.components.AddMemo.mod")
								: t("pages.portfolio.PortfolioMemo.components.AddMemo.enroll")}
						</button>
					</div>
				</Form>
			</div>

			{filesFields?.length > 0 && (
				<ul className="file-preview">
					{filesFields.map((f, index) => {
						console.log("~~~", f);
						const { name } = f.file;
						return (
							<li className="preview-item">
								<div className="preview-text">
									<ClipIcon />
									<span>{name}</span>
								</div>
								<button
									className="btn-round-delete"
									onClick={() => {
										removeFile(index, f.idx);
									}}
								>
									<RoundMinusIcon />
								</button>
							</li>
						);
					})}
				</ul>
			)}
			{/* 메모 파일 등록 preview */}
			{/* <ul className="file-preview">
        <li className="preview-item">
          <div className="preview-text">
            <ClipIcon />
            <span>0000.pdf</span>
          </div>
          <button className="btn-round-delete">
            <RoundMinusIcon />
          </button>
        </li>
        <li className="preview-item">
          <div className="preview-text">
            <ClipIcon />
            <span>0000.pdf</span>
          </div>
          <button className="btn-round-delete">
            <RoundMinusIcon />
          </button>
        </li>
      </ul> */}
		</>
	);
};

export default AddMemo;
